/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-04-14 11:51:04
 * @LastEditors: 南岸有归
 * @Description: 
 * @FilePath: \cloud_frontend\src\api\task.js
 * @
 */
import http from '@/axios/http'
import { getuser_id } from "@/localStorage/localStorage";

//获取所有分组，查询在线设备
export function getGroupList(allDevice = 0) {
    const data = {
        allDevice,
        allGroup: 1,
        user_id: getuser_id(),
        offset: 1,
        limit: 99999
    }
    return http({
        url: '/api/device/getGroupList',
        method: 'post',
        data
    })
}
//添加升级任务
export function addLevelUp(name, description, dids, path, spFileSize, spId, keepConfig, server, packageType) {
    const data = {
        name: name,
        description: description,
        dids: dids,
        path: path,
        spFileSize: spFileSize,
        spId: spId,
        keepConfig: keepConfig,
        server,
        packageType
    }
    if (data.packageType === '') {
        delete data.packageType
    }
    return http({
        url: '/api/levelUp/addLevelUp',
        method: 'post',
        data
    })
}

//添加配置任务
export function addConfig(name, description, dids, path, cfFileSize, spId) {
    const data = {
        name: name,
        description: description,
        dids: dids,
        path: path,
        spFileSize: cfFileSize,
        spId: spId
    }
    return http({
        url: '/api/configTask/addConfig',
        method: 'post',
        data
    })
}
// 新增api
//获取分组下的设备，获取到版本集合
export function findCanLevelUp(groupId) {
    return http({
        url: '/api/device/findCanLevelUp',
        method: 'post',
        data: { groupId }
    })
}

//通过分组id获取分组下的设备
export function GroupDevices(gid,queryType,limit, offset, sn){
    return http({
        url: '/api/device/group/devices',
        method: 'post',
        data: { gid, queryType, limit, offset, sn }
    })
}

//获取一二三级分组
export function getAddLevel3Group(pid) {
    return http({
        url: '/api/device/getAddLevelGroup',
        method: 'post',
        data:{pid}
    })
}

//获取获取子任务
export function GetListConfig(parentTid) {
    return http({
        url: '/api/configTask/sub/listConfig',
        method: 'post',
        data:{parentTid}
    })
}
